import { clsx } from "clsx";
import { TriangleAlert } from "lucide-react";

export function WeatherAlert({
	message,
	className,
	title,
}: {
	message: string;
	className?: string;
	title?: string;
}) {
	return (
		<div
			className={clsx("weather-alert", className)}
			role="status"
			title={title}
		>
			<TriangleAlert className="weather-alert__icon" />
			<span>{message}</span>
		</div>
	);
}
